// Module
var code = "<p>Sahip izinleri hesap üzerinde kimin kontrolü olduğunu belirler. Sahipler tüm anahtarların yenilerini belirleyebilir ve herhangi hesap ayarını değiştirebilir.</p> <p>Daha fazla bilgi için <a href=\"accounts/permissions\">izinler</a> .</p> ";
// Exports
export default code;